import React from 'react'
import style from './articles.style'

const Megaplan = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Подключение CRM Мегаплан</h2>
      <strong>Шаг 1. Настройка авторизации CRM</strong>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan2.jpg" alt="true" />
      </figure>
      <ol className={classes.articleList}>
        <li>
          Введите URL-адрес вашего проекта в Мегаплан. Обычно он выглядит так:{' '}
          <strong>{`https://<site>.megaplan.ru`}</strong>
        </li>
        <li>
          В поле <strong>Email</strong> введите адрес электронной почты для
          авторизации в Мегаплан.
        </li>
        <li>
          В поле <strong>Пароль</strong> введите пароль, который указываете при
          входе в Мегаплан.
        </li>
        <li>
          В поле <strong>UUID ключ</strong> введите UUID ключ Мегаплан. Для
          этого зайдите в Мегаплан и скопируйте его из профиля пользователя:
        </li>
      </ol>

      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan4.jpg" alt="true" />
      </figure>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan12.jpg" alt="true" />
      </figure>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan5.jpg" alt="true" />
      </figure>

      <p>
        Перейдите в раздел <strong>“Приложения”</strong>
      </p>

      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan1.jpg" alt="true" />
      </figure>

      <ol className={classes.articleList}>
        <li>
          Поставьте галочку{' '}
          <strong>“Пользователи могут устанавливать приложения-виджеты”</strong>
        </li>
        <li>
          Нажмите кнопку <strong>“Создать приложение”</strong>
        </li>
      </ol>

      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan10.jpg" alt="true" />
      </figure>

      <ol className={classes.articleList}>
        <li>
          Укажите название <strong>ROMI center</strong>
        </li>
        <li>
          Нажмите кнопку <strong>“Сохранить”</strong>
        </li>
      </ol>

      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan6.jpg" alt="true" />
      </figure>

      <ol className={classes.articleList}>
        <li>
          В URL принимающий события укажите{' '}
          <strong>“https://romi.center/api/megaplan”</strong>
        </li>
        <li>
          Поставьте галочку <strong>“deals”</strong>
        </li>
        <li>
          Нажмите кнопку <strong>“Сохранить”</strong>
        </li>
        <li>
          Скопируйте <strong>UUID</strong> ключ и вставьте его в модуле
          подключения CRM Мегаплан в личном кабинете ROMI center.
        </li>
      </ol>

      <strong>
        Шаг 2. Настройка пользовательского поля для передачи Google Client Id
      </strong>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan9.png" alt="true" />
      </figure>
      <ol className={classes.articleList}>
        <li>Нажмите на иконку аккаунта</li>
        <li>Выберите “Настройки”</li>
        <li>Выберите “Бизнес-процессы и сделки”</li>
        <li>Выберите “Продажи”</li>
        <li>
          Добавьте свойство в разделе “Свойства сделок в статусе «Входящая
          заявка»” - “Дополнительные свойства”
        </li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/megaplan3.png" alt="true" />
        </figure>
        <li>Введите название свойства</li>
        <li>Выберите тип: “Строка”</li>
        <li>Установите максимальную длину 36</li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/megaplan11.png" alt="true" />
        </figure>
        <li>Установите чекбокс “В журнале изменений” у созданного свойства</li>
        <figure className={classes.helpArticleFigure}>
          <img src="/images/megaplan8.png" alt="true" />
        </figure>
      </ol>

      <p>
        Далее это поле будет использоваться для передачи Google Client Id из
        форм заявок или интеграций.
      </p>

      <strong>Шаг 3. Расширенная настройка</strong>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/megaplan7.png" alt="true" />
      </figure>

      <ol className={classes.articleList}>
        <li>
          Выберите, куда хотите отправлять данные. Мы рекомендуем отправлять
          данные в <strong>“Покупки в электронной торговле”</strong>. Отправка
          данных в <strong>Электронную торговлю</strong> позволяет передавать
          идентификатор сделки, сумму сделки, факт оплаты или возврата по
          сделке. После подключения коннектора мы включим Электронную коммерцию
          в выбранном ранее представлении Google Analytics. Отправка данных в
          <strong>Цель “Успешные продажи”</strong>, позволяет передавать только
          сумму продаж. Если выбрать отправку данных в цель, то после
          подключения коннектора мы создадим цель "Успешные продажи MegaPlan" в
          выбранном ранее представлении Google Analytics.
        </li>
        <li>
          Выберите статусы сделки, которые соответствуют{' '}
          <strong>“Успешно завершенной сделке”</strong>. Можно выбрать несколько
          статусов, если вам необходимо например учитывать разные способы
          оплаты: “Оплата безналом” и “Оплата наличными”. Обратите внимание, что
          одна сделка не может проходить через два статуса оплаты. Пример:
          “Предоплата” и “Полная оплата”, в таком случае сделка задублируется в
          отчете продаж.
        </li>
        <li>
          Выберите статус <strong>“Возврата”</strong> в вашей CRM системе. Эта
          опция доступна, только в случае, если выбрана отправка в{' '}
          <strong>Электронную торговлю</strong>. Статус “Возврат” не является
          обязательным полем, вы можете выбрать значение “НЕ ВЫБРАНО”. Статус
          возврата нужно выбирать, если у вас предусмотрен возврат денежных
          средств клиенту за товар или услугу. Данные о возвратах также
          отправляются в отчет о продажах. Обратите внимание, что переводить
          сделку в статус возврат необходимо в случае, если ранее, она была
          завершена как “успешная”.
        </li>
        <li>
          Выберите поле CRM, в которое передается{' '}
          <strong>Google Client ID</strong>. Пример Client ID:
          “GA1.2.2029541258.1577186246" (GA1.2.XXXXXXXXXX.XXXXXXXXXX). Если вы
          не знаете, есть ли у вас в CRM поле <strong>“Client ID”</strong>,
          выберите “НЕ ВЫБРАНО”, позже вы сможете настроить это поле в личном
          кабинете ROMI center. Обратитесь в тех. поддержку ROMI center, чтобы
          вам помогли с параметром Client ID.
        </li>
        <li>
          Нажмите кнопку <strong>“Завершить”</strong>.
        </li>
      </ol>

      <p>
        Проверьте корректность введенных данных, на вновь загруженной странице.
      </p>
      <p>
        Нажмите кнопку <strong>“Вернуться на дашборд”</strong>.
      </p>
      <p>Готово!</p>
    </article>
  )
}

export default style(Megaplan)
